export default class ErrorDialog extends React.Component {
  /**
   * @param {{
   *  errorMessage: string,
   * }} props
   */
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.errorMessage) {
      return (
        <span className="yext-oauth__error"> {this.props.errorMessage} </span>
      );
    }
    return (null);
  }
}
